import { render, staticRenderFns } from "./fitnessCenterDisplay.vue?vue&type=template&id=3179cc59&scoped=true"
import script from "./fitnessCenterDisplay.vue?vue&type=script&lang=js"
export * from "./fitnessCenterDisplay.vue?vue&type=script&lang=js"
import style0 from "./fitnessCenterDisplay.vue?vue&type=style&index=0&id=3179cc59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179cc59",
  null
  
)

export default component.exports